import React, { useState, useEffect, useRef } from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import SpeechRecorder from '../sa/saSpeechRecorder';
import TextArea from '../../utils/test/textarea';

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { choices },
		leftSectionProps: { videoId, question, imagesrc, queDesc, qdomain, qtype, prompt },
		questionId
	} = state.rootReducer.testPageDetails;

	return {
		choices,
		videoId,
		question,
		imagesrc,
		queDesc,
		qdomain,
		qtype,
		prompt,
		questionId
	};
};
const SaSpeech = ({
	choices,
	videoId,
	question,
	imagesrc,
	queDesc,
	qdomain,
	qtype,
	prompt,
	questionId
}) => {

	const set2mins = (qtype === 'LA' && qdomain === 'S') ? true : false;

	const seconds = (set2mins) ? 45 : 0
	
	const [timeLeft, setTimeLeft] = useState(seconds);

	if(questionId !== Number(localStorage.getItem('cQuestionId'))) {
		localStorage.setItem('cQuestionId', questionId)
		setTimeLeft(seconds)
	}

	useEffect(() => {
		// exit early when we reach 0
		if (!timeLeft) return;

		// save intervalId to clear the interval when the
		// component re-renders
		const intervalId = setInterval(() => {
			setTimeLeft(timeLeft - 1);
		}, 1000);

		// clear interval on re-render to avoid memory leaks
		return () => clearInterval(intervalId);
	}, [timeLeft]);

	return (
		<section className="que-container">
			<section className="quiz-page-content">
				<TopQuestion hideTitle={set2mins}/>
				{set2mins && timeLeft > 0 ? (
					<div className='speechCounter'>
						<h1>{timeLeft}</h1>
						<span>Please use this time to prepare your answer.</span>
					</div>
				) : (
					<section className="quiz-area-options">
						<h6>{prompt}</h6>
						{qdomain === 'S' ? <SpeechRecorder key={questionId} /> : <TextArea key={questionId} />}
					</section>
				)}
				
			</section>
		</section>
	);
};

export default connect(mapStateToProps)(SaSpeech);
